import { createState } from "@videojs/store";
import { animationFrame } from "@videojs/utils/dom";
//#region src/dom/ui/time-slider/seek.ts
/** Hold the clicked position until seeking and the presentation layer's transition finish. @internal */
function createTimeSliderSeek(property) {
	const state = createState({ percent: void 0 });
	let cancel;
	let seeking = false;
	let element = null;
	function frame() {
		const transitioning = element?.getAnimations?.().some((animation) => "transitionProperty" in animation && animation.transitionProperty === property && animation.playState !== "finished");
		if (seeking || transitioning) {
			cancel = animationFrame(frame);
			return;
		}
		cancel = void 0;
		state.patch({ percent: void 0 });
	}
	function seek(percent) {
		cancel?.();
		state.patch({ percent });
		cancel = animationFrame(frame);
	}
	return {
		state,
		seek,
		update(next, percent, el) {
			element = el;
			if (next && !seeking && state.current.percent === void 0) seek(percent);
			seeking = next;
		},
		destroy() {
			cancel?.();
			cancel = void 0;
			seeking = false;
			element = null;
			state.patch({ percent: void 0 });
		}
	};
}
//#endregion
export { createTimeSliderSeek };
